import { render } from "./RequisicoesListadmin.vue?vue&type=template&id=615d9df4&scoped=true"
import script from "./RequisicoesListadmin.vue?vue&type=script&lang=js"
export * from "./RequisicoesListadmin.vue?vue&type=script&lang=js"

import "./RequisicoesListadmin.vue?vue&type=style&index=0&id=615d9df4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-615d9df4"]])

export default __exports__